import React from "react";

type SvgProps = React.SVGProps<SVGSVGElement>;

export const AddPerson = (props: SvgProps) => (
  <svg
    {...props}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_6114_26992)">
      <path
        d="M8 10C8.79113 10 9.56448 9.76541 10.2223 9.32588C10.8801 8.88635 11.3928 8.26164 11.6955 7.53074C11.9983 6.79983 12.0775 5.99556 11.9231 5.21964C11.7688 4.44372 11.3878 3.73098 10.8284 3.17157C10.269 2.61216 9.55628 2.2312 8.78036 2.07686C8.00444 1.92252 7.20017 2.00173 6.46927 2.30448C5.73836 2.60723 5.11365 3.11992 4.67412 3.77772C4.2346 4.43552 4 5.20888 4 6C4.00106 7.06054 4.42283 8.07734 5.17274 8.82726C5.92266 9.57718 6.93946 9.99894 8 10ZM8 3.33334C8.52742 3.33334 9.04299 3.48973 9.48152 3.78275C9.92005 4.07577 10.2618 4.49224 10.4637 4.97951C10.6655 5.46678 10.7183 6.00296 10.6154 6.52024C10.5125 7.03753 10.2586 7.51268 9.88562 7.88562C9.51268 8.25856 9.03752 8.51254 8.52024 8.61543C8.00296 8.71832 7.46678 8.66551 6.97951 8.46368C6.49224 8.26185 6.07576 7.92005 5.78275 7.48152C5.48973 7.04299 5.33333 6.52742 5.33333 6C5.33333 5.29276 5.61428 4.61448 6.11438 4.11438C6.61448 3.61429 7.29276 3.33334 8 3.33334V3.33334Z"
        fill="currentColor"
      />
      <path
        d="M15.9993 8.66601V6.66602H14.666V8.66601H12.666V9.99934H14.666V11.9993H15.9993V9.99934H17.9993V8.66601H15.9993Z"
        fill="currentColor"
      />
      <path
        d="M10.6953 11.334H5.30467C4.42854 11.335 3.5886 11.6836 2.96908 12.3031C2.34957 12.9226 2.00106 13.7625 2 14.6387L2 18.0007H3.33333V14.6387C3.33386 14.116 3.54173 13.6149 3.91131 13.2453C4.28089 12.8757 4.782 12.6678 5.30467 12.6673H10.6953C11.218 12.6678 11.7191 12.8757 12.0887 13.2453C12.4583 13.6149 12.6661 14.116 12.6667 14.6387V18.0007H14V14.6387C13.9989 13.7625 13.6504 12.9226 13.0309 12.3031C12.4114 11.6836 11.5715 11.335 10.6953 11.334V11.334Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_6114_26992">
        <rect width="16" height="16" fill="white" transform="translate(2 2)" />
      </clipPath>
    </defs>
  </svg>
);
